export type BrandLens = 'all' | 'suki' | 'bbq';

export const BRAND_LENSES: { value: BrandLens; label: string }[] = [
  { value: 'all', label: 'ทุกแบรนด์' },
  { value: 'suki', label: 'ลัคกี้สุกี้' },
  { value: 'bbq', label: 'ลัคกี้บาร์บีคิว' },
];

export function lensFromQuery(value: unknown): BrandLens {
  return value === 'suki' || value === 'bbq' ? value : 'all';
}

export function apiBrand(lens: BrandLens): string | undefined {
  return lens === 'suki' ? 'lucky_suki' : lens === 'bbq' ? 'lucky_bbq' : undefined;
}

export function brandQuery(lens: BrandLens): string | undefined {
  return lens === 'all' ? undefined : lens;
}

/** Data-scope label for card captions / page headers (audit Part 5, bead gp83). */
export function scopeLabel(lens: BrandLens): string {
  switch (lens) {
    case 'suki': return 'เฉพาะลัคกี้สุกี้';
    case 'bbq': return 'เฉพาะลัคกี้บาร์บีคิว';
    default: return 'รวมทุกแบรนด์';
  }
}

/** Brand-lens empty-state label (audit Part 5). */
export function brandEmptyLabel(lens: BrandLens): string {
  return lens === 'bbq' ? 'ยังไม่มีข้อมูลเฉพาะลัคกี้บาร์บีคิวในช่วงเวลานี้' : 'ยังไม่มีข้อมูลเฉพาะลัคกี้สุกี้ในช่วงเวลานี้';
}

/**
 * Short brand tag for row-level disambiguation. Same-mall Suki/BBQ branches
 * share identical name_th (e.g. "โลตัส สระบุรี" x2), so lists that mix
 * brands must tag each row. PO decision 2026-08-19: tags are the uppercase
 * SUKI / BBQ only — no "Lucky"/"ลัคกี้" prefix. Matching is fuzzy
 * (substring) so any code shape resolves: 'lucky_suki', 'lucky-suki',
 * 'suki', 'lucky_bbq', 'bbq'. Returns '' for unknown codes so callers can
 * render untagged without a guard.
 */
export function brandShortTag(code: string | null | undefined): string {
  if (!code) return '';
  const c = code.toLowerCase();
  if (c.includes('suki')) return 'SUKI';
  if (c.includes('bbq') || c.includes('barbecue')) return 'BBQ';
  return '';
}

/**
 * Derives the SUKI / BBQ tag from the branch name itself, for API shapes
 * that carry no brand code. Recognizes the seed-name prefixes
 * ("Lucky Suki …" / "Lucky BBQ …") and their Thai forms
 * ("ลัคกี้สุกี้ …" / "ลัคกี้บาร์บีคิว …"). Returns '' when no known
 * prefix matches.
 */
export function brandTagFromName(name: string | null | undefined): string {
  if (!name) return '';
  const n = name.toLowerCase();
  if (n.startsWith('lucky suki') || n.startsWith('ลัคกี้สุกี้')) return 'SUKI';
  if (n.startsWith('lucky bbq') || n.startsWith('lucky barbecue') || n.startsWith('ลัคกี้บาร์บีคิว')) return 'BBQ';
  return '';
}
